import type { Point } from "./types";

const GTP_COLUMNS = "ABCDEFGHJKLMNOPQRSTUVWXYZ";

export function pointKey(point: Point): string {
  return `${point.x},${point.y}`;
}

export function samePoint(a: Point, b: Point): boolean {
  return a.x === b.x && a.y === b.y;
}

export function isOnBoard(point: Point, size: number): boolean {
  return point.x >= 0 && point.x < size && point.y >= 0 && point.y < size;
}

export function pointToLabel(point: Point, size: number): string {
  return `${GTP_COLUMNS[point.x]}${size - point.y}`;
}

export function pointToGtp(point: Point, size: number): string {
  return pointToLabel(point, size);
}

export function gtpToPoint(vertex: string, size: number): Point | null {
  const normalized = vertex.trim().toUpperCase();
  if (!normalized || normalized === "PASS") {
    return null;
  }

  const column = GTP_COLUMNS.indexOf(normalized[0]);
  const row = Number(normalized.slice(1));
  if (column < 0 || !Number.isFinite(row)) {
    return null;
  }

  const point = { x: column, y: size - row };
  return isOnBoard(point, size) ? point : null;
}

export function cornerPoint(
  size: number,
  corner: "nw" | "ne" | "sw" | "se",
  fromSide: number,
  fromTopOrBottom: number
): Point {
  return {
    x: corner.includes("w") ? fromSide - 1 : size - fromSide,
    y: corner.includes("n") ? fromTopOrBottom - 1 : size - fromTopOrBottom
  };
}

export function neighbors(point: Point, size: number): Point[] {
  return [
    { x: point.x - 1, y: point.y },
    { x: point.x + 1, y: point.y },
    { x: point.x, y: point.y - 1 },
    { x: point.x, y: point.y + 1 }
  ].filter((candidate) => isOnBoard(candidate, size));
}

